import React, { useState } from 'react';
import { Button, Modal, Form, Input } from 'antd';

import { saveAs } from 'file-saver';

export const JsonDownloadDetailsModal = ({
  jsonDownloadType,
  jsonDownloadModal,
  jsonDownloadName,
  libraryData,
  filteredDataSource,
  imageDownloadIds,
  setJsonDownloadModal,
  setJsonDownloadName,
  setImageDownloadIds,
}) => {
  const handleJsonDownload = () => {
    let libraryDataToDownload = [];

    if (jsonDownloadType === 'filtered') {
      libraryData.forEach((libraryItem, index) => {
        const found = filteredDataSource.find(
          (filterData) =>
            filterData.identifier === libraryItem.metadata.identifier
        );
        if (found) {
          libraryDataToDownload.push(libraryItem);
        }
      });
    } else if (jsonDownloadType === 'checked') {
      let newLibraryItemIndex = 0;
      libraryData.forEach((libraryItem, index) => {
        if (imageDownloadIds.includes(libraryItem.id)) {
          const { metadata, tm30 } = libraryItem;
          newLibraryItemIndex += 1;
          const newLibraryItem = {
            id: newLibraryItemIndex,
            metadata: metadata,
            tm30,
          };
          libraryDataToDownload.push(newLibraryItem);
        }
      });
    } else if (jsonDownloadType === 'full') {
      libraryDataToDownload = libraryData;

      // Code to generate and sort example library
      // libraryData.forEach((libraryItem, index) => {
      //   const target = `EX${index + 1}`;
      //   const newItem = libraryData.find(
      //     (data) => data.metadata.identifier.split(":")[0] == target
      //   );
      //   const { id, metadata, tm30 } = newItem || {};
      //   const newEntry = {
      //     id: index + 1,
      //     metadata: metadata,
      //     tm30,
      //   };
      //   libraryDataToDownload.push(newEntry);
      // });
    }

    setImageDownloadIds([]);
    const stringifyJson = JSON.stringify(libraryDataToDownload);
    const blob = new Blob([stringifyJson], { type: 'application/json' });
    saveAs(blob, `${jsonDownloadName}.json`);
    setJsonDownloadModal(false);
  };

  return (
    <Modal
      title="JSON Download"
      visible={jsonDownloadModal}
      onCancel={() => setJsonDownloadModal(false)}
      footer={[
        <Button
          style={{ marginRight: '1rem' }}
          key="cancel"
          onClick={() => setJsonDownloadModal(false)}
        >
          Cancel
        </Button>,
        <Button
          key="download-dropdown"
          type="primary"
          onClick={handleJsonDownload}
        >
          Download
        </Button>,
      ]}
    >
      <Form>
        <Form.Item label="Name">
          <Input
            value={jsonDownloadName}
            onChange={(event) => setJsonDownloadName(event.target.value)}
          />
        </Form.Item>
        {/* <Form.Item label="Select download type">
            <Radio.Group
              onChange={(event) => setJsonDownloadType(event.target.value)}
              value={jsonDownloadType}
            >
              <Radio value="full">Full</Radio>
              <Radio value="checked">Checked</Radio>
              <Radio value="filtered">Filtered</Radio>
            </Radio.Group>
          </Form.Item> */}
      </Form>
    </Modal>
  );
};
